import type { CustomerRecord } from '@/domain/types';
import { customerName } from '@/utils/format';
import CustomerFlagChips from '@/components/CustomerFlagChips';
import clsx from 'clsx';

export interface CustomerRecordHeaderProps {
  customer: CustomerRecord;
}

export default function CustomerRecordHeader({ customer }: CustomerRecordHeaderProps) {
  const score = customer.leadScore;
  const chipClass = clsx(
    'inline-flex items-center px-3 py-1 rounded-full text-xs uppercase tracking-widest font-inter',
    score >= 80
      ? 'bg-gold-bright text-ink-black'
      : score >= 50
        ? 'border border-gold-bright text-gold-bright'
        : 'border border-cream-soft text-cream-soft',
  );
  return (
    <header
      data-testid={`customer-header-${customer.id}`}
      className="bg-ink-dark border-b border-gold-dim/20 px-8 py-6 flex items-start justify-between gap-4"
    >
      <div>
        <h1
          className="font-inter text-[40px] leading-tight text-gold-bright"
          data-testid="customer-record-name"
        >
          {customerName(customer)}
        </h1>
        <p className="font-mono text-sm text-cream-soft mt-2 flex flex-wrap gap-x-6 gap-y-1">
          <span>{customer.phone}</span>
          {customer.email ? <span>{customer.email}</span> : null}
          {customer.instagramHandle ? <span>{customer.instagramHandle}</span> : null}
        </p>
        <p className="font-inter text-xs text-cream-soft mt-2 uppercase tracking-widest">
          {customer.suburb}, {customer.state} {customer.postcode} ·{' '}
          {customer.distanceToNearestStudioKm}km to {customer.nearestStudioId.replace('-', ' ')}
        </p>
      </div>
      <div className="flex flex-col items-end gap-2">
        <span className={chipClass}>Lead score {score}</span>
        <span className="pill-cream text-[10px]">{customer.leadStage}</span>
        <span className="pill-cream text-[10px]">{customer.engagementStatus}</span>
        <CustomerFlagChips customer={customer} className="justify-end max-w-[240px]" />
      </div>
    </header>
  );
}
